
var UMUM = require('../library/umum');

export default {
  data() {
    return {
      filterTahun: new Date().getFullYear(),
      listTahun: [2026, 2027],
      dashboardData: [],
      totalOpd: { pagu: 0, keuangan: 0, persenKeuangan: 0, persenFisik: 0, kombinasi: 0 },
      totalKecamatan: { pagu: 0, keuangan: 0, persenKeuangan: 0, persenFisik: 0, kombinasi: 0 },
      grandTotal: { pagu: 0, kontrak: 0, keuangan: 0 },
      loadingDashboard: false,
      UMUM: UMUM,
    }
  },
  computed: {
  },
  methods: {
    getDashboard() {
      this.loadingDashboard = true;
      this.$store.commit("shoWLoading");

      fetch(this.$store.state.url.CT_REALISASI_FISIK_KEUANGAN + "dashboard", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          tahun: this.filterTahun
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.dashboardData = res_data.list || [];
          this.totalOpd = res_data.totalOpd || this.totalOpd;
          this.totalKecamatan = res_data.totalKecamatan || this.totalKecamatan;
          this.grandTotal = res_data.grandTotal || this.grandTotal;

          this.loadingDashboard = false;
          this.$store.commit("hideLoading");
        })
        .catch(err => {
          console.error('getDashboard error', err);
          this.loadingDashboard = false;
          this.$store.commit("hideLoading");
        });
    },
    formatTanggalPrint() {
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      const d = new Date();
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    formatWaktuPrint() {
      const d = new Date();
      let h = d.getHours();
      let m = d.getMinutes();
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      return `${h}.${m}`;
    },
    buildTableRows() {
      let rowsHtml = '';
      let nonKec = this.dashboardData.filter(d => !d.nama_instansi.toUpperCase().includes('KECAMATAN'));
      let kec = this.dashboardData.filter(d => d.nama_instansi.toUpperCase().includes('KECAMATAN'));

      // OPD rows
      nonKec.forEach((data, i) => {
        const styleKeu = data.realisasi_keuangan_persen < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
        const styleFisik = data.realisasi_fisik_persen < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
        const styleKomb = data.realisasi_kombinasi < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
        rowsHtml += `<tr>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${i + 1}</td>
          <td style="border:1px solid #000;padding:4px;">${data.nama_instansi}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(data.total_pagu)}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(data.total_realisasi_keuangan)}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;${styleKeu}">${data.realisasi_keuangan_persen}%</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;${styleFisik}">${data.realisasi_fisik_persen}%</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;${styleKomb}">${data.realisasi_kombinasi}%</td>
        </tr>`;
      });

      // JUMLAH OPD
      rowsHtml += `<tr style="background-color:#ffc000;font-weight:bold;font-style:italic;">
        <td colspan="2" style="text-align:right;border:1px solid #000;padding:4px;padding-right:20px;">JUMLAH</td>
        <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(this.totalOpd.pagu)}</td>
        <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(this.totalOpd.keuangan)}</td>
        <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalOpd.persenKeuangan}%</td>
        <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalOpd.persenFisik}%</td>
        <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalOpd.kombinasi}%</td>
      </tr>`;

      if (kec.length > 0) {
        // HEADER KECAMATAN
        rowsHtml += `<tr style="background-color:#b8cce4;">
          <td colspan="7" style="font-weight:bold;border:1px solid #000;padding:5px 10px;">KECAMATAN</td>
        </tr>`;

        // Kecamatan rows
        kec.forEach((data, i) => {
          const styleKeu = data.realisasi_keuangan_persen < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
          const styleFisik = data.realisasi_fisik_persen < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
          const styleKomb = data.realisasi_kombinasi < 100 ? 'color:#c00000' : 'color:#375623;font-weight:bold';
          rowsHtml += `<tr>
            <td style="text-align:center;border:1px solid #000;padding:4px;">${i + 1}</td>
            <td style="border:1px solid #000;padding:4px;">${data.nama_instansi}</td>
            <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(data.total_pagu)}</td>
            <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(data.total_realisasi_keuangan)}</td>
            <td style="text-align:center;border:1px solid #000;padding:4px;${styleKeu}">${data.realisasi_keuangan_persen}%</td>
            <td style="text-align:center;border:1px solid #000;padding:4px;${styleFisik}">${data.realisasi_fisik_persen}%</td>
            <td style="text-align:center;border:1px solid #000;padding:4px;${styleKomb}">${data.realisasi_kombinasi}%</td>
          </tr>`;
        });

        // JUMLAH KECAMATAN
        rowsHtml += `<tr style="background-color:#ffc000;font-weight:bold;font-style:italic;">
          <td colspan="2" style="text-align:right;border:1px solid #000;padding:4px;padding-right:20px;">JUMLAH</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(this.totalKecamatan.pagu)}</td>
          <td style="text-align:right;border:1px solid #000;padding:4px;">${this.UMUM.Rupiah(this.totalKecamatan.keuangan)}</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalKecamatan.persenKeuangan}%</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalKecamatan.persenFisik}%</td>
          <td style="text-align:center;border:1px solid #000;padding:4px;">${this.totalKecamatan.kombinasi}%</td>
        </tr>`;
      }

      return rowsHtml;
    },
    cetakPDF() {
      const tanggal = this.formatTanggalPrint();
      const waktu = this.formatWaktuPrint();
      const rowsHtml = this.buildTableRows();

      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>Laporan Realisasi Fisik dan Keuangan ${this.filterTahun}</title>
          <style>
            @page { size: landscape; margin: 10mm; }
            body { font-family: Arial, sans-serif; font-size: 9pt; color: #000; background: white; }
            h3 { text-align: center; margin: 0; padding: 0; font-size: 11pt; }
            .tanggal { font-weight: bold; font-style: italic; background-color: yellow; display: inline-block; padding: 3px 6px; margin: 12px 0 8px 0; font-size: 10pt; }
            table { width: 100%; border-collapse: collapse; margin-top: 8px; }
            th { border: 1px solid #000; padding: 5px; text-align: center; background-color: #d9d9d9; }
            th.col-realisasi { background-color: #fff2cc; }
            th.col-kombinasi { background-color: #fce4d6; }
            td { border: 1px solid #000; padding: 4px; }
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          </style>
        </head>
        <body>
          <h3>PERSENTASE LAPORAN REALISASI FISIK DAN KEUANGAN</h3>
          <h3>JENIS PENGADAAN : KONSTRUKSI, KONSULTANSI, BARANG DAN JASA LAINNYA</h3>
          <h3 style="text-decoration:underline;">KABUPATEN KONAWE SELATAN T.A ${this.filterTahun}</h3>
          <div class="tanggal">Tanggal ${tanggal}, Pukul ${waktu} WITA</div>
          <table>
            <thead>
              <tr>
                <th rowspan="2" width="4%">No</th>
                <th rowspan="2" width="28%">ORGANISASI PERANGKAT DAERAH</th>
                <th rowspan="2" width="13%">Anggaran (Rp.)</th>
                <th colspan="2" class="col-realisasi">Realisasi</th>
                <th rowspan="2" width="8%" class="col-realisasi">Fisik (%)</th>
                <th rowspan="2" width="12%" class="col-kombinasi">Realisasi Keuangan dan Fisik (%)</th>
              </tr>
              <tr>
                <th width="15%" class="col-realisasi">Keuangan (Rp)</th>
                <th width="8%" class="col-realisasi">Keuangan (%)</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
          <script>
            window.onload = function() { window.print(); }
          <\/script>
        </body>
        </html>
      `;

      const printWindow = window.open('', '_blank', 'width=1100,height=700');
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    },
  },

  mounted() {
    this.getDashboard();
  },
}
